import { Box, Card, Paper } from "@mui/material";
import LocationCityIcon from '@mui/icons-material/LocationCity';
import Tooltip from "@mui/material/Tooltip";
import MDTypography from "components/MDTypography";

export const PermissionBuildingCard = (props) => {
  return (
    <Card
      sx={{
        width: {
          xs: "325px",
        },
        // Remove hover cursor since this card is not clickable
        cursor: 'default',
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        ml={1}
        mr={1.25}
        my={-0.5}
        sx={{
          padding: "12px 0px 4px 0px",
        }}
      >
        <Box className="container">
          <Box
            className="topContainer"
            sx={{
              display: "flex",
              width: "19.5rem",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Paper
                className="buildingIcon"
                color={"white"}
                elevation={1}
                style={{
                  background: "blue",
                }}
                sx={{
                  padding: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "3rem",
                  height: "3rem",
                }}
              >
                <LocationCityIcon 
                  sx={{
                    color: "#fff",
                    scale: "2",
                  }}
                />
              </Paper>
              <MDTypography
                fontSize={16}
                sx={{
                  overflowWrap: "anywhere",
                  marginLeft: "1rem",
                  fontWeight: "bold",
                  color: "#000",
                }}
              >
                {props.name ? `${props.name}` : props.id}
              </MDTypography>
            </Box>
          </Box>
          <Box sx={{ marginTop: ".5rem", width: "19rem" }}>
            <Tooltip
              title={
                <div style={{ textAlign: "left" }}>
                  City: {props.city || 'Not specified'}
                  <br />
                  Street: {props.street || 'Not specified'} 
                  <br />
                  Devices: {props.devices_count || 0} 
                </div>
              }
            >
              <MDTypography
                fontSize={14}
                sx={{
                  fontWeight: "regular",
                  color: "#000",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  marginLeft: "",
                }}
             >
                <>
                  <div>Country: {props.country || "Not specified"}</div>
                  <div>City: {props.city || "Not specified"}</div>
                  <div>Street: {props.street || "Not specified"}</div>  
                  <div>Devices: {props.devices_count || 0}</div>
                </>
              </MDTypography>
            </Tooltip>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "7px",
        }}
      >
      </Box>
    </Card> 
   );
}; 

export default PermissionBuildingCard;